import {
  Concern,
  ConcernThread,
  MessageType,
  Message,
  MessageUserInfo,
} from '../../apis/messaging/messaging.interfaces';
import { mockUsers } from '../messaging/conversationParticipants.mock';

const guardianUser = mockUsers[0];
const staffUser = mockUsers[1];

export const mockConcerns: Concern[] = [
  {
    id: 'c1',
    _id: 'c1',
    sender_id: guardianUser._id,
    content: 'My child is struggling with mathematics. Need extra support.',
    type: MessageType.CONCERN,
    institute_ref: 'inst1',
    is_read: false,
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    concern_metadata: {
      subject: 'Mathematics support needed',
      description: 'My child is struggling with mathematics. Need extra support.',
      category: 'academic',
      priority: 'high',
      student_id: 's1',
    },
    sender: guardianUser,
  },
  {
    id: 'c2',
    _id: 'c2',
    sender_id: guardianUser._id,
    content: 'Bus pickup timing issue - often late',
    type: MessageType.CONCERN,
    institute_ref: 'inst1',
    is_read: true,
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    concern_metadata: {
      subject: 'Transport timing',
      description: 'Bus pickup timing issue - often late',
      category: 'transport',
      priority: 'medium',
      student_id: 's1',
    },
    sender: guardianUser,
  },
  {
    id: 'c3',
    _id: 'c3',
    sender_id: guardianUser._id,
    content: 'Fee payment clarification needed',
    type: MessageType.CONCERN,
    institute_ref: 'inst1',
    is_read: false,
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    concern_metadata: {
      subject: 'Fee structure query',
      description: 'Fee payment clarification needed',
      category: 'fees',
      priority: 'low',
      student_id: 's1',
    },
    sender: guardianUser,
  },
];

function createReplyMessage(
  id: string,
  sender: MessageUserInfo,
  content: string,
  createdAt: Date
): Message {
  return {
    id,
    _id: id,
    sender_id: sender._id,
    content,
    type: MessageType.DIRECT_MESSAGE,
    institute_ref: 'inst1',
    is_read: true,
    created_at: createdAt.toISOString(),
    sender,
  };
}

export const mockConcernThread: ConcernThread = {
  concern_id: 'c1',
  concern: mockConcerns[0],
  messages: [
    createReplyMessage(
      'r1',
      staffUser,
      'We have noted your concern. We will arrange extra math classes from next week.',
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
    ),
    createReplyMessage(
      'r2',
      guardianUser,
      'Thank you for the quick response. When will the classes start?',
      new Date(Date.now() - 12 * 60 * 60 * 1000)
    ),
    createReplyMessage(
      'r3',
      staffUser,
      'Classes will start from Monday. Your child will receive a separate timetable.',
      new Date(Date.now() - 6 * 60 * 60 * 1000)
    ),
  ],
};
